import {useSearchParams} from "react-router-dom";
import React from "react";
import {ChatComponent} from "./ChatComponent";
import {Enums} from "./Enums";

export default function ChatProvider() {

    const [searchParams, setSearchParams] = useSearchParams();


    const chatId = searchParams.get('chat_id');

    return <ChatComponent chat_id={chatId} mode={Enums.ChatMode.CHANNEL}/>
}
